import { type AppState } from "@/redux/store";

// This is defined in `next-redux-wrapper` but we redefine it here
// to avoid ballooning the bundle size by importing the entire library
export const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

/**
 * This action will be triggered on initial page load, as well as any client-side
 * transitions to pages that use `getServerSideProps` or `getStaticProps`.
 */
export type HydrateAction = {
  type: typeof HYDRATE;
  payload: AppState;
};

export type HydrationState = {
  hasHydrated: boolean;
};

export const initialState: HydrationState = {
  hasHydrated: false,
};

export default (
  state: HydrationState = initialState,
  action: HydrateAction,
): HydrationState => {
  switch (action.type) {
    case HYDRATE:
      return {
        hasHydrated: true,
      };
    default:
      return state;
  }
};
